import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

const styleMap = {
  xlarge: {
    desktop: {
      fontSize: 20,
      lineHeight: 29
    },
    tablet: {
      fontSize: 16,
      lineHeight: 22
    },
    mobile: {
      fontSize: 14,
      lineHeight: 20
    }
  },
  large: {
    desktop: {
      fontSize: 18,
      lineHeight: 27
    },
    tablet: {
      fontSize: 15,
      lineHeight: 27
    },
    mobile: {
      fontSize: 14,
      lineHeight: 24
    }
  },
  medium: {
    desktop: {
      fontSize: 15,
      lineHeight: 27
    },
    tablet: {
      fontSize: 15,
      lineHeight: 27
    },
    mobile: {
      fontSize: 14,
      lineHeight: 24
    }
  },
  small: {
    desktop: {
      fontSize: 13,
      lineHeight: 20
    },
    tablet: {
      fontSize: 12,
      lineHeight: 19
    },
    mobile: {
      fontSize: 11,
      lineHeight: 18
    }
  }
};

const Paragraph = styled.p`
  font-size: ${props => styleMap[props.size || 'medium'].desktop.fontSize}px;
  font-weight: 400;
  line-height: ${props => styleMap[props.size || 'medium'].desktop.lineHeight}px;

  & + & {
    margin-top: 1em;
  }

  ${maxMediaQueries.tablet`
    font-size: ${props => styleMap[props.size || 'medium'].tablet.fontSize}px;
    line-height: ${props => styleMap[props.size || 'medium'].tablet.lineHeight}px;
    margin-bottom: 1em;
  `};

  ${maxMediaQueries.phone`
    font-size: ${props => styleMap[props.size || 'medium'].mobile.fontSize}px;
    line-height: ${props => styleMap[props.size || 'medium'].mobile.lineHeight}px;
  `};
`;

export default Paragraph;
